import { PresetFrame, type PresetArtProps } from './PresetFrame';

export function Rocket(props: PresetArtProps) {
  return (
    <PresetFrame background="#4338ca" {...props}>
      <path d="M32 9 Q45 19 42 42 H22 Q19 19 32 9 Z" fill="#ffffff" />
      <path d="M22 32 L14 46 H23 Z M42 32 L50 46 H41 Z" fill="#ffffff" />
      <circle cx="32" cy="26" r="4.5" fill="#1f2937" />
      <path d="M26 44 H38 L32 56 Z" fill="#f59e0b" />
    </PresetFrame>
  );
}
